import { render, staticRenderFns } from "./host-common-text.vue?vue&type=template&id=2599c628&scoped=true&"
import script from "./host-common-text.vue?vue&type=script&lang=js&"
export * from "./host-common-text.vue?vue&type=script&lang=js&"
import style0 from "./host-common-text.vue?vue&type=style&index=0&id=2599c628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599c628",
  null
  
)

export default component.exports